import React, { FC } from 'react'
import { ArtistItem } from 'modules/Projects/components'

import { ProjectsListProps } from './ProjectsList.props'

const ProjectsList: FC<ProjectsListProps> = ({ units, projects }) => (
  <div className="project-list">
    {projects.map((artist) => (
      <ArtistItem artist={artist} units={units} key={artist.id} />
    ))}
  </div>
)

export default ProjectsList
